import React from "react";
import useStyles from "../style";
import { TextField } from "@material-ui/core";

const InputDisable = ({ value, type, label, name, placeholder }) => {
    const classes = useStyles();

    return (
        <div>
            <label className={classes.label} >{label}</label>
            <TextField
                disabled="true"
                InputProps={{
                    classes: {
                        focused: classes.textBorder,
                        input: classes.input,

                    },
                }}
                value={value != "Vigencia" || value == '' ? value + " días" : value}
                placeholder={placeholder}
                type={type}
                name={name}
                style={{ width: '85%' }}
                inputStyle={{ width: '85%' }}
            />
        </div>
    );
}

export default InputDisable;